import produce from 'immer';
import { AppActionTypes } from '../../model/application/actions';
import { DialogTranscriptionState } from '../../model/transcription/types';
import { fillTranscriptionActionType, fillTranscriptionsActionType, fillTranscriptionSpeechActionType } from '../../model/transcription/action';

const initialState: DialogTranscriptionState = {
  transcriptions: [],
  pageCount: 0
};

export function dialogTranscriptionReducer(
  state = initialState,
  action: AppActionTypes,
): DialogTranscriptionState {
  switch (action.type) {
    case fillTranscriptionsActionType.success:
      return produce(state, draftState => {
        draftState.transcriptions = action.payload.result
        draftState.pageCount = action.payload.pageCount
      })
    case fillTranscriptionsActionType.failure:
      return produce(state, draftState => {
        draftState.transcriptions = [];
        draftState.pageCount = 0
    })
    case fillTranscriptionSpeechActionType.success:
    return produce(state, draftState => {
      draftState.transcriptions[draftState.transcriptions.findIndex(item => item.id === action.payload.dialogId)].speeches = action.payload.speeches
    })
    case fillTranscriptionActionType.success:
    return produce(state, draftState => {
      draftState.transcriptions = []
      draftState.transcriptions.push(action.payload.transcription)
    })
    default:
      return state;
  }
}


